<!--
 * @Author: Ximen
 * @Date: 2021-03-23 19:40:08
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-14 21:01:48
-->
<template>
  <a-card class="box">
    <p class="title">认证资料提交成功</p>
    <img class="blank" src="@/assets/undraw_Post_re_mtr4.png" alt="">
    <a-button type="primary" class="accept-btn" @click="backToHome">返回商城首页</a-button>
  </a-card>
</template>

<script>
import { defineComponent } from 'vue';
import environment from '@/untils/environment';

export default defineComponent({
  name: 'SubmitSuccess',
  components: {
  },
  methods: {
    async backToHome() {
      console.log(123);
      const accountId = await localStorage.getItem('accountId');
      const memberId = await localStorage.getItem('memberId');
      const token = await localStorage.getItem('token');
      const siteId = await localStorage.getItem('siteId');
      const loc = window.location;
      const uri = loc.host;
      const url = `http://${uri.indexOf('pre') === -1 ? 'hdsupport.saas.seatent.com' : 'hdsupport.saas.saaspre.seatent.com'}/#/callback?randomCode=42rfmhh9x73juwvw&approach=22&token=${token}&accountId=${accountId}&appkey=${environment.appkey}&siteId=${siteId}&memberId=${memberId}&link=/home/go`;
      console.log(url);
      window.location.href = url;
    },
  },
});
</script>
<style lang="stylus" scoped>
    .box
      margin 0 auto
      border-radius 20px
      width 420px
      .title
        font-size 24px
        color #073D7D
        margin-bottom 40px
      .blank
        width 220px
        height auto
        margin-bottom 40px
      .accept-btn
        width 100%
        height 50px
        margin-top 10px
        border-radius 5px
        background #F1F1F1
        margin-bottom 30px
        color #3281DD
        border none
</style>
